export const toCategory = (apiCategory) => {
  return {
    id: apiCategory.categoryName,
    name: apiCategory.categoryName,
    published: apiCategory.active,
    query: apiCategory.query,
    description: apiCategory.description || apiCategory.categoryDescription,
    tags: apiCategory.tags ? [...apiCategory.tags] : [],
    created: apiCategory.dateCreated,
    lastModified: apiCategory.dateModified,
    version: apiCategory.version,
    notes: apiCategory.notes,
  };
};

export const toAPICategory = (category) => {
  return {
    categoryName: category.id,
    active: category.published || false,
    query: category.query,
    description: category.description || '',
    categoryDescription: category.description || '',
    tags: category.tags,
    version: category.version || '',
    notes: category.notes || '',
  };
};
